export function hasCommonElement(array1, array2) {
    const setArray2 = new Set(array2);
    return array1.some(element => setArray2.has(element));
}